module.exports = __webpack_public_path__ + "img/back-to-all-options-black.4d4d1a72.svg";